/**
 * Keeps the announcement bar and the header both pinned to the top.
 *
 * Both are sticky in CSS: the announcement bar at top 0, the header directly
 * beneath it. The header's offset has to match the announcement bar's real
 * height, which varies with font size and message length, so it's measured here
 * and published as --announcementH for the stylesheet to use.
 */
(function () {
  'use strict';

  /* Section-group wrapper for the announcement bar. The suffix is its stable
     key in sections/header-group.json; the prefix varies per template. */
  var BAR_SELECTOR = '[id^="shopify-section-"][id$="__1774049828dcbaa6a8"]';

  function measure() {
    var bar = document.querySelector(BAR_SELECTOR);
    var height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--announcementH', height + 'px');
  }

  function watch() {
    measure();

    /* Height can settle after fonts load or the message slider starts. */
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);

    var bar = document.querySelector(BAR_SELECTOR);
    if (bar && window.ResizeObserver) {
      new ResizeObserver(measure).observe(bar);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  document.addEventListener('shopify:section:load', measure);
})();
